import { put, select } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/selectors";
import messages from "rdx/modules/compensation/messages";
import { camelizeKeys } from "lib/helpers";

function* distributePayment(action) {
  const { payload } = action;

  const { success, data, error } = yield* makeRequest.post(`/compensation/pay_periods/${payload.id}/distribute`, {});

  if (success && data) {
    const payments = yield select(selectors.getPayPeriods);
    const updatedPeriods = payments.payPeriods.map((p) => (p.id === data.body.id ? data.body : p));
    const out = { ...payments, payPeriods: camelizeKeys(updatedPeriods) };

    yield put(actions.setPayments(out));
    yield put(
      actions.newSuccessEvent({
        message: messages.DISTRIBUTE_PAYMENT_SUCCESS,
      }),
    );
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_DISTRIBUTING_PAYMENT,
    });
  }

  return null;
}

export default distributePayment;
